/**
 * Content service API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ImageSpecification { 
    imageSize: ImageSpecification.ImageSizeEnum;
    extensions: Array<ImageSpecification.ExtensionsEnum>;
}
export namespace ImageSpecification {
    export type ImageSizeEnum = 'XS' | 'S' | 'M' | 'L' | 'XL' | 'XXL' | 'XXXL' | 'ORIGINAL';
    export const ImageSizeEnum = {
        XS: 'XS' as ImageSizeEnum,
        S: 'S' as ImageSizeEnum,
        M: 'M' as ImageSizeEnum,
        L: 'L' as ImageSizeEnum,
        XL: 'XL' as ImageSizeEnum,
        XXL: 'XXL' as ImageSizeEnum,
        XXXL: 'XXXL' as ImageSizeEnum,
        ORIGINAL: 'ORIGINAL' as ImageSizeEnum
    };
    export type ExtensionsEnum = 'jpg' | 'webp' | 'gif' | 'png';
    export const ExtensionsEnum = {
        JPG: 'jpg' as ExtensionsEnum,
        WEBP: 'webp' as ExtensionsEnum,
        GIF: 'gif' as ExtensionsEnum,
        PNG: 'png' as ExtensionsEnum
    };
}


